import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { IStore } from '../redux/reducers'
import isIosApp from '../helpers/iosApp'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	overflow: hidden;
`
const Container = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: auto;
`

const withResizer = (Component: any, maxWidth: number, maxHeight: number) => {
	//TODO: find a way to avoid using any here
	const resizer = class Resizer extends React.PureComponent<any> {
		constructor(props: any) {
			super(props)
		}

		render() {
			const containerWidth = isIosApp ? this.props.width : Math.min(maxWidth, this.props.width)
			const containerHeight = isIosApp ? this.props.height : Math.min(maxHeight, this.props.height)
			const containerRel = containerWidth / containerHeight
			const originalRel = maxWidth / maxHeight

			let finalWidth, finalHeight
			if (originalRel > containerRel) {
				finalWidth = containerWidth
				finalHeight = finalWidth / originalRel
			} else {
				finalHeight = containerHeight
				finalWidth = isIosApp ? containerWidth : finalHeight * originalRel
			}
			const finalLeft = (containerWidth - finalWidth) / 2
			const finalTop = (containerHeight - finalHeight) / 2

			return (
				<Container
					style={{
						width: `${containerWidth}px`,
						height: `${containerHeight}px`,
					}}
				>
					<Wrapper
						style={{
							fontSize: `${(100 * finalHeight) / maxHeight}px`,
							width: `${finalWidth}px`,
							height: `${finalHeight}px`,
							left: `${finalLeft}px`,
							top: `${finalTop}px`,
						}}
					>
						<Component {...(this.props as any)} containerScale={finalHeight / maxHeight} />
					</Wrapper>
				</Container>
			)
		}
	}
	const mapStateToProps = (state: IStore) => {
		return {
			width: state.app.size.width,
			height: state.app.size.height,
		}
	}
	return connect(mapStateToProps)(resizer)
}

export default withResizer
